export interface IMessage {
    content: string;
    time: string;  // ISO string or readable format
    isMe: boolean; // true if the message is sent by the user, false if received from the AI,
    searchType: SearchType;
    refs?: DocumentRef[]| undefined; // Array of document references related to the message
}

export enum ChatModes {
    STANDARD_CHAT = "Chat",
    ADVANCED_CHAT = "AdvanceChat",
    PEP_CHAT = "PepChat"
}

export enum SearchType {
    LLSearch,
    NonSC3Search,
    PepSearch,
}

export interface DocumentRef {
    highLights: string;
    title: string;
    accessMediatorUrl: string;
    rerankerScore: number;
}